import { isNumber } from 'remeda';

export function numberOrNull(value: number | string): number | null {
  if (isNumber(value)) return value;

  if (value === '') return null; // Number('') === 0 in js

  const parsed = Number(value);
  if (Number.isNaN(parsed)) return null;

  return Number(value);
}
